export default __webpack_public_path__ + "static/media/tete39.49552836.png";